import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
    } catch (err) {
      // Expected on first-time visit; no need to log.
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me if returning from Emergent OAuth (session_id in hash)
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    // Cookie is set by backend; no client-side token storage needed.
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("logout failed:", err);
    }
    setUser(null);
  };
  const setSessionUser = (u) => {
    // Emergent OAuth path — backend has already set the cookie during /auth/session
    setUser(u);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setSessionUser, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
